/** tempexp_14728-full-file
 * Все упоминания <FeatureSelector selector={getFeatureNewContentGrid} .../>
 */
import classNames from 'clsx';
import React, { memo, ReactElement } from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

import AlbumsItem from './components/Items/AlbumsItem';
import AlldocumentsItem from './components/Items/AlldocumentsItem';
import ArchiveItem from './components/Items/ArchiveItem';
import AttachesItem from './components/Items/AttachesItem';
import FavoritesItem from './components/Items/FavoritesItem';
import FeedItem from './components/Items/FeedItem';
import GalleryItem from './components/Items/GalleryItem';
import HomeItem from './components/Items/HomeItem';
import PublicItem from './components/Items/PublicItem';
import QuotaCleanerItem from './components/Items/QuotaCleanerItem';
import SearchItem from './components/Items/SearchItem';
import SharedAutodeleteItem from './components/Items/SharedAutodeleteItem';
import SharedIncomingItem from './components/Items/SharedIncomingItem';
import StockItem from './components/Items/StockItem';
import TrashbinItem from './components/Items/TrashbinItem';
import styles from './DataListItemRow.css';
import newStyles from './DataListItemRow.new.css';
import { DataListItemRowProps } from './DataListItemRow.types';

export const DataListItemRow = memo((props: DataListItemRowProps): ReactElement => {
    const { isVKEmbedded, isSelected, isMobile, isSelecting, isActive } = props;

    const renderItem = (props: DataListItemRowProps) => {
        // eslint-disable-next-line sonarjs/max-switch-cases
        switch (props.storage) {
            case EStorageType.archive:
                return <ArchiveItem {...props} />;
            case EStorageType.sharedIncoming:
                return <SharedIncomingItem {...props} />;
            case EStorageType.home: {
                return <HomeItem {...props} />;
            }
            case EStorageType.albums: {
                return <AlbumsItem {...props} />;
            }
            case EStorageType.sharedLinks:
            case EStorageType.sharedAutodelete:
                return <SharedAutodeleteItem {...props} />;
            case EStorageType.public:
                return <PublicItem {...props} />;
            case EStorageType.favorites:
                return <FavoritesItem {...props} />;
            case EStorageType.stock:
                return <StockItem {...props} />;
            case EStorageType.search: {
                return <SearchItem {...props} />;
            }
            case EStorageType.feed: {
                return <FeedItem {...props} />;
            }
            case EStorageType.alldocuments: {
                return <AlldocumentsItem {...props} />;
            }
            case EStorageType.gallery: {
                return <GalleryItem {...props} />;
            }
            case EStorageType.attaches:
                return <AttachesItem {...props} />;
            case EStorageType.trashbin: {
                return <TrashbinItem {...props} />;
            }
            case EStorageType.quotaCleaner: {
                return <QuotaCleanerItem {...props} />;
            }
        }
    };

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            control={
                <div
                    className={classNames(styles.root, {
                        [styles.root_desktop]: !isMobile,
                        [styles.root_selected]: isSelected,
                        [styles.root_active]: isActive,
                        [styles.root_selecting]: isSelecting,
                        [styles.root_vk_embedded]: isVKEmbedded,
                        [styles.root_responsive]: ENABLE_FULL_RESPONSIVE,
                        [styles.root_xl]:
                            (props.storage === EStorageType.sharedIncoming ||
                                props.storage === EStorageType.gallery ||
                                props.storage === EStorageType.search) &&
                            ENABLE_FULL_RESPONSIVE,
                    })}
                >
                    {renderItem(props)}
                </div>
            }
            variant1={
                <div
                    className={classNames(newStyles.root, {
                        [styles.root_vk_embedded]: isVKEmbedded,
                        [newStyles.root_selected]: isSelected,
                        [newStyles.root_active]: isActive,
                        [newStyles.root_selecting]: isSelecting,
                    })}
                >
                    {renderItem(props)}
                </div>
            }
        />
    );
});

DataListItemRow.displayName = 'DataListItemRow';
DataListItemRow.whyDidYouRender = true;
